<template>

   <sdPageHeader>
      <template #title>
      <a-row :gutter="30">
        <a-col>
        <div class="product-single-description">
          <sdHeading class="product-single-title" as="h1" style="margin: 15px">
           Monthly Calls Tracking Report
          </sdHeading>
          <span style="margin: 0px; font-size: 16px; font-weight: 400">
          </span>
        </div>
        </a-col>
        </a-row>
        <ProductCard
    class="list-view"
    :style="{ width: '100%', marginBottom: '10px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;">
            <a-form
              name="contact"
              :rules="rules"
              :model="formState"
              @submit="handleOk"
              :layout="vertical"
            >
            <a-row :gutter="20">
            <a-col :md="4">
              <a-form-item name="organization" label="Domain">
                <a-select
                  v-model:value="formState.organization"
                  style="width: 100%"
                  showSearch
                >
                <a-select-option
                  v-for="item in orgData"
                  v-bind:key="item.organization"
                  :value="item.organization"
                >
                  {{ item.organization }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!--<a-col :md="4">
              <a-form-item name="center" label="center">
                <a-select
                  v-model:value="formState.center"
                  style="width: 100%"
                  showSearch
                >
                <a-select-option
                  v-for="item in branchData"
                  v-bind:key="item.branch_code"
                  :value="item.branch_code"
                >
                  {{ item.branch_code }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="5">
            <a-form-item name="team" label="team">
            <a-select
                v-model:value="formState.team"
                style="width: 100%"
                @change="onChange"
                showSearch
                >
                <a-select-option
                value="SME"
                >SME
                </a-select-option>
                <a-select-option
                value="Accounting"
                >Accounting
                </a-select-option>
            </a-select>    
            </a-form-item>
            </a-col>-->
            <!--<a-col :md="8">
            <a-form-item name="Comparative Period" label="Comparative Period">
            <a-select
                v-model:value="formState.recent"
                style="width: 100%"
                @change="onChange1"
                showSearch
                >
                <a-select-option
                value="3"
                >3 Months
                </a-select-option>
                <a-select-option
                value="6"
                >6 Months
                </a-select-option>
                <a-select-option
                value="12"
                >1 Year
                </a-select-option>
            </a-select>    
            </a-form-item>
            </a-col>
            <a-col :md="4">
              <a-form-item name="source">
                <a-select
                  v-model:value="formState.source"
                  style="width: 100%"
                  showSearch
                >
                <a-select-option
                  v-for="item in sourceData"
                  v-bind:key="item.Source_type"
                  :value="item.Source_type"
                >
                  {{ item.Source_type }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4">
            <a-form-item name="condition">
             <a-range-picker
                  style="padding-top: 10px !important"
                  @change="DateSelect"
                  :defaultValue="selectrange"
                  required
                />   
            </a-form-item>
            </a-col>-->
            <a-col :md="4">
            <a-form-item>
              <a-button 
                htmlType="submit"
                size="default"
                type="primary"
                key="submit"
                class="btn-add_new"
                style="margin-top: -1.5px !important;"
              >
               <span style="display: inline-flex !important;
              align-items: center !important;">
              <sdFeatherIcons type="arrow-down-circle" size="14" />  &nbsp; 
              Get Report</span>
              </a-button>
             </a-form-item>
              </a-col>
             
              </a-row>
            </a-form>
          </div>
          </ProductCard>
      </template>
     
    </sdPageHeader>
     
  <Main>
  <sdCards headless v-if="loading">
        <div class="spin">
          <a-spin />
        </div>
      </sdCards>
  <sdCards headless v-else>
    <sdHeading class="product-single-title" as="h3" style="margin: 10px">
    List of Leads
    </sdHeading>
      <template v-if="selectedoption == 'Active'">
      <a-row :gutter="15" style="padding: 10px">
            
            <a-col :xs="24">
              <TopToolBox>
                <div class="product-single-description">
                  <div
                    class="
                      product-single-title
                      page-header-actions
                      product-single-description
                    "
                    style="float: right"
                  >
                    <a-button
                      class="btn-signin"
                      size="small"
                      type="default"
                      v-if="checkselected"
                      @click="bulkIgnore('B')"
                    >
                      <span
                        style="
                          display: inline-flex !important;
                          align-items: center !important;
                        "
                      >
                        <sdFeatherIcons type="x-circle" size="14" /> &nbsp;
                        Dismiss</span
                      >
                    </a-button>
                    
                    <a-button class="btn-signin" size="small" @click="exportToCSV()">
                      <span
                        style="
                          display: inline-flex !important;
                          align-items: center !important;
                        "
                      >
                        <sdFeatherIcons type="download" size="14" /> &nbsp;
                        Export</span
                      >
                    </a-button>
                  </div>
                  <span style="margin: 0px; font-size: 16px; font-weight: 400">
                    <br />
                  </span>
                </div>
              </TopToolBox>
            </a-col>
          </a-row> 
        <a-row :gutter="15">
          <a-col :md="24">
             <TableWrapper class="table-responsive">
              <a-table
                class="ant-table-striped"
                thead-class="greenColor"
                :data-source="TableData"
                :columns="TableColumns"
                :row-class-name="
                  (_record, index) => (index % 2 === 1 ? 'table-striped' : null)
                "
                :pagination="{
                    defaultPageSize: 15,
                    total: TableData.length,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                }"
              >
              </a-table>
            </TableWrapper>
          </a-col>
        </a-row>
      </template>
      
    </sdCards>
  </Main>
</template> 
<script>
import { ContactPageheaderStyle, Action, UserTableStyleWrapper ,ProjectSorting,TopToolBox,} from '../../style';
import { defineComponent } from 'vue';
import { Main, CardToolbox, TableWrapper,BasicFormWrapper } from '../../../styled';
import { dispatch, useStore } from 'vuex';
import { ProductCard } from "./style";
import { defineAsyncComponent, computed, reactive, ref, onMounted, watch , h} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { message, Notification } from 'ant-design-vue'; 
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
export default defineComponent({
  name: 'CallsTrackingReport',
  components: {
    Main,
    CardToolbox,
    BasicFormWrapper,
    UserTableStyleWrapper,
    TableWrapper,ProjectSorting,TopToolBox,ProductCard,
  },
  setup() {
    var loading = ref(true);
    var branchData = ref();
    var orgData = ref();
    var sourceData = ref();
    var userData = ref();
    var industryData = ref();
    var checkselected = ref(false);
    var selectcount = ref(null);
    var selectedid = ref(null);
    var selectedoption = ref('Active');
    var selectrange = ref(null);
    var dispInterest = ref(false);
    var dispProb = ref(false);
    const { dispatch, state } = useStore();
    const selectedChange = ref(null);
    const selectedChange1 = ref(null);
    const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT; 
    state.CurrentData.data = [];
    onMounted(() => {
    getdata();
    monthlyData();
    }); 
    const formState = reactive({
      organization: "Corient-UK",
      center: "UK",
      team: "Accounting",
      source: "Select Data Source",
      industry: "Select Industry",
      probability: "Select Probability",
      recent: 1,
      });
    const rules = {
      center: [
        {
          required: true,
          message: "Please select center first",
          trigger: "blur",
        },
      ],
      team: [
        {
          required: true,
          message: "Please select team first",
          trigger: "blur",
        },
      ],
      recent: [
        {
          required: true,
          message: "Please select period first",
          trigger: "blur",
        },
      ],
      };
    const DateSelect = (date, dateString) => {
      selectrange.value = dateString;
    };
    const handleOk = (values) => {
      monthlyData();
    };
    const onChange=(change)=> {
     selectedChange.value=change;
     if(selectedChange.value=="SME"){
     dispInterest.value=true;
     }
     else{
      dispInterest.value=false;
     }
    }
    const onChange1=(change)=> {
     selectedChange1.value=change;
     if(selectedChange1.value=="probability"){
     dispProb.value=true;
     }
     else{
      dispProb.value=false;
     }
    }
    const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
        selectedRowKeys.value = selectedRowKeys;
        selectedRows.value = selectedRows; 
        if (selectedRowKeys.value.length == 0) {
          checkselected.value = false;
        } else {
          checkselected.value = true;
          selectedid = selectedRowKeys.value;
          selectcount.value = selectedRowKeys.value.length + ' Rows Selected';
        }
      },
     
    };
  const getdata = () => {
      loading.value = true;
      dispatch("manualFieldsData").then(
        (response) => {
          if (response.status == 200) {
            industryData.value = response.data[0];
            branchData.value = response.data[3];
            sourceData.value = response.data[4];
            orgData.value = response.data[8];
            loading.value = false;
          } else {
            loading.value = false;
            //onCancel();
          }
        },
        (error) => {
          console.log(error);
          loading.value = false;
        }
      );
      
    };
    const monthlyData = () => {
        let api_data = [];
        api_data['organization'] = formState.organization;
        //api_data['center'] = formState.center;
        //api_data['team'] = formState.team;
        //api_data['recent'] = formState.recent;
        //api_data['source'] = formState.source;
        //api_data['startdate'] = startdate;
        //api_data['enddate'] = enddate;
        //api_data['industry'] = formState.industry;
        //api_data['probability'] = formState.probability;
        loading.value = true;
        dispatch("CallsTrackingReport",api_data).then(
            (response) => {
                if (response.status == 200) {
                    state.CurrentData.data = response.data;
                    Notification["success"]({
                    message: "Succsess!",
                    description: "Report Loaded.",
                    });
                    loading.value = false;
                } else {
                    loading.value = false;
                    //onCancel();
                }
            },
            (error) => {
                loading.value = false;
                state.CurrentData.data = [];
                Notification["error"]({
                message: "Error!",
                description: "Error Loading Leads",
            });
          } 
          
        );
        //}
    }
    const makeStatusColumn = (title, dataIndex) => ({
      title,
      dataIndex,
      key: dataIndex,
      align:'left',
      customRender: ({ text, record }) => {
        return h(
          'a',
          {
            href: `/call-detail-report/${dataIndex}?user_id=${record.user_id}&organization=${formState.organization}`,
          },
          text
        );
      },
    });
    const TableColumns = [
      {
        title: "User",
        dataIndex: "user_id",
        key: "user_id",
        sorter: (a, b) => a.user_id.length - b.user_id.length,
        sortDirections: ["descend", "ascend"],
      },
      makeStatusColumn("Scheduled for Past Months", "scheduled_past_count"),
      makeStatusColumn("Scheduled for Current Month", "scheduled_present_count"),
      makeStatusColumn("Scheduled for Upcoming Month", "scheduled_future_count"),
    ];
    
   
     let TableData = computed(() =>
        state.CurrentData.data.map((unreconcile) => {
          const {
            id,
            user_id,
            scheduled_past_count,
            scheduled_present_count,
            scheduled_future_count,
            } = unreconcile;
            var linedata = [];
          return {
            key: user_id,
            user_id: user_id,
            scheduled_past_count: scheduled_past_count,
            scheduled_present_count:scheduled_present_count,
            scheduled_future_count:scheduled_future_count,
            } 
            
        }
        )
    );

    const exportToCSV = () => {
      const inputData = state.CurrentData.data.map((unreconcile) => {
        const {
          id,
          user_id,
          scheduled_past_count,
          scheduled_present_count,
          scheduled_future_count,
        } = unreconcile;
        return {
          User: user_id,
          "Scheduled for Past Months":scheduled_past_count,
          "Scheduled for Current Month":scheduled_present_count,
          "Scheduled for Upcoming Month": scheduled_future_count,
          };
      });

      var linedata = [];

      
      //var range = selectrange.value.toString().split(",");
      const fileName ="Calls Tracking Report";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const ws = XLSX.utils.json_to_sheet(inputData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);

      Notification["success"]({
        message: "Success!",
        description: "Downloaded.",
      });
    };
    return {
      loading,
      TableColumns,
      TableData,
      branchData,
      orgData,
      userData,
      sourceData,
      rowSelection,
      selectcount,
      checkselected,
      selectedoption,
      handleOk,
      exportToCSV,
      formState,
      selectrange,
      dispInterest,
      DateSelect,
      rules,
      onChange,
      dispProb,
      onChange1,
      selectedChange1,
      selectedChange,
      industryData,
      makeStatusColumn,
     };
  },
});
</script> 
<style scoped>
.ant-table-striped :deep(.table-striped) td th{
  background-color: #447316;
}
th {
  //background-color: #93BF34 !important;
}
.ant-btn-primary {
  background-color: #5C69B3 !important;
  border: 1px solid #5C69B3 !important;
}
.supp-head div{
        width: 250px;
}

.ant-col .ant-select {
  margin-top: 4px;
}
.ant-col button{
  margin-top: 5px;
}
table thead tr th:last-child {
    text-align: left !important;
}
.ant-page-header-heading {
  display: block !important;

}
</style>